import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import { addFilters } from "../../store/slices/FilterSlice";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchStates,
  fetchStatesOffice,
  fetchDealer,
  fetchDealercode,
  fetchDivision,
  fetchProductLine,
  fetchLOB,
  fetchPPL,
  fetchPL,
  fetchRegulator,
  reducer,
} from "./apiRetailFilters";

//*------------------COMP----------------------*//
export default function RetailFilter({ isFormVisible, setFormVisible }) {
  const { data, submitted } = useSelector((state) => state.filters);

  const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    state: pState,
    state_office: pStateOffice,
    dealer_name: pDealer,
    dealer_code: pDealerCode,
    division_name: pDivision,
    Product_Line: pProductLine,
    lob: pLob,
    ppl: pPpl,
    pl: pPl,
    regulator_Name: pRegulator,
  } = data;

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStateOffice, setSelectedStateOffice] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [selectedDealerCode, setSelectedDealerCode] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);
  const [selectedPpl, setSelectedPPL] = useState([]);
  const [selectedPl, setSelectedPL] = useState([]);
  const [selectedRegulator, setSelectedRegulator] = useState([]);
  // const [isFormVisible, setFormVisible] = useState(false);
  //* ---------------USE QUERY---------------------/

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["states", submitted, pRegion],
    queryFn: () => fetchStates(pRegion),
    initialData: [],
  });

  const { data: statesoffice, isLoading: soL } = useQuery({
    queryKey: ["statesoffice", submitted, pRegion, pState],
    queryFn: () => fetchStatesOffice(pRegion, pState),
    initialData: [],
  });

  // console.log(statesoffice);

  const { data: dealer, isLoading: dL } = useQuery({
    queryKey: ["dealer", submitted, pRegion, pState, pStateOffice],
    queryFn: () => fetchDealer(pRegion, pState, pStateOffice),
    initialData: [],
  });

  const { data: dealercode, isLoading: dcL } = useQuery({
    queryKey: ["dealercode", submitted, pRegion, pState, pStateOffice, pDealer],
    queryFn: () => fetchDealercode(pRegion, pState, pStateOffice, pDealer),
    initialData: [],
  });

  const { data: division, isLoading: diL } = useQuery({
    queryKey: [
      "division",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
    ],
    queryFn: () =>
      fetchDivision(pRegion, pState, pStateOffice, pDealer, pDealerCode),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: [
      "productLine",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
    ],
    queryFn: () =>
      fetchProductLine(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision
      ),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: [
      "lob",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
    ],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine
      ),
    initialData: [],
  });

  const { data: ppl, isLoading: pplL } = useQuery({
    queryKey: [
      "ppl",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
    ],
    queryFn: () =>
      fetchPPL(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob
      ),
    initialData: [],
  });

  const { data: pl, isLoading: plL1 } = useQuery({
    queryKey: [
      "pl",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
      pPpl,
    ],
    queryFn: () =>
      fetchPL(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
        pPpl
      ),
    initialData: [],
  });

  const { data: regulator, isLoading: regL } = useQuery({
    queryKey: [
      "regulator",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
      pPpl,
      pPl,
    ],
    queryFn: () =>
      fetchRegulator(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
        pPpl,
        pPl
      ),
    initialData: [],
  });
  //* ---------------HANDLE EVENTS---------------------/
  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        state: pState || selectedState,
        state_office: pStateOffice || selectedStateOffice,
        dealer_name: pDealer || selectedDealer,
        dealer_code: pDealerCode || selectedDealerCode,
        division_name: pDivision || selectedDivision,
        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
        ppl: pPpl || selectedPpl,
        pl: pPl || selectedPl,
        regulator_Name: pRegulator || selectedRegulator,
      },
      submitted: clicked + 1,
    };

    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };

  //*----------------------JSX-------------------------/
  return (
    <section className="">
      {isFormVisible && (
        <div className="border-[#2c8a8b] border rounded-md  grid grid-cols-2 gap-2 p-2 md:gap-2 lg:grid-cols-[repeat(13,minmax(0,1fr))] md:grid-cols-4">
          <div className={divStyle}>
            <label className={labelStyle}>Region</label>
            <ViMultiSelect
              options={regions}
              onSelectionChange={setSelectedRegion}
              opnsSelected={pRegion}
              keey="region"
              isLoading={rL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>State</label>
            <ViMultiSelect
              options={states}
              onSelectionChange={setSelectedState}
              opnsSelected={pState}
              keey="state"
              isLoading={sL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>State Office</label>
            <ViMultiSelect
              options={statesoffice}
              onSelectionChange={setSelectedStateOffice}
              opnsSelected={pStateOffice}
              keey="state_office"
              isLoading={soL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Dealer Name</label>
            <ViMultiSelect
              options={dealer}
              onSelectionChange={setSelectedDealer}
              opnsSelected={pDealer}
              keey="dealer_name"
              isLoading={dL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Dealer Code</label>
            <ViMultiSelect
              options={dealercode}
              onSelectionChange={setSelectedDealerCode}
              opnsSelected={pDealerCode}
              keey="dealer_code"
              isLoading={dcL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Division</label>
            <ViMultiSelect
              options={division}
              onSelectionChange={setSelectedDivision}
              opnsSelected={pDivision}
              keey="division_name"
              isLoading={diL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Product Line</label>
            <ViMultiSelect
              options={productLine}
              onSelectionChange={setSelectedProductLine}
              opnsSelected={pProductLine}
              keey="Product_Line"
              isLoading={plL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>LOB</label>
            <ViMultiSelect
              options={lob}
              onSelectionChange={setSelectedLOB}
              opnsSelected={pLob}
              keey="lob"
              isLoading={lobL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>PPL</label>
            <ViMultiSelect
              options={ppl}
              onSelectionChange={setSelectedPPL}
              opnsSelected={pPpl}
              keey="ppl"
              isLoading={pplL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>PL</label>
            <ViMultiSelect
              options={pl}
              onSelectionChange={setSelectedPL}
              opnsSelected={pPl}
              keey="pl"
              isLoading={plL1}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Regul.Names</label>
            <ViMultiSelect
              options={regulator}
              onSelectionChange={setSelectedRegulator}
              opnsSelected={pRegulator}
              keey="regulator_Name"
              isLoading={regL}
            />
          </div>

          <div className="grid gap-2 lg:col-span-2 lg:grid lg:grid-cols-2">
            <div className="self-end">
              <button
                className=" text-white w-full rounded-sm  bg-[#2A5775] "
                type="button"
                onClick={handleSearch}
              >
                Apply
              </button>
            </div>

            <div className="self-end">
              <button
                className=" text-white bg-[#2A5775] rounded-sm w-full"
                onClick={handleRefresh}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

//*------------------CSS----------------------*//
const divStyle = "flex flex-col justify-center";
const labelStyle = "font-semibold py-1 text-xs text-[#2A5775]";
